/** Yandex xarita vidjeti (kalitsiz). pts: «lon,lat,belgi». Ikki nuqta bo'lsa — bbox ikkalasini ham sig'diradi. */
export function yandexWidget(pts: string[]): string {
  if (!pts.length) return ""
  const base = `https://yandex.uz/map-widget/v1/?pt=${pts.join("~")}`
  if (pts.length === 1) return base + "&z=14"
  const ll = pts.map((p) => p.split(",").map(Number))
  const lons = ll.map((x) => x[0]), lats = ll.map((x) => x[1])
  const pad = Math.max(Math.max(...lons) - Math.min(...lons), Math.max(...lats) - Math.min(...lats)) * 0.15 + 0.002
  return `${base}&bbox=${Math.min(...lons) - pad},${Math.min(...lats) - pad}~${Math.max(...lons) + pad},${Math.max(...lats) + pad}`
}
